import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { useMutation } from "@tanstack/react-query";
import usersApis from "../../api/methods/users";

interface ChangePasswordModalProps {
  visible: boolean;
  setVisiblity: (visiblity: boolean) => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  visible,
  setVisiblity,
}) => {
  const [form] = Form.useForm();
  const { mutate: changePass, isPending: changing } = useMutation({
    mutationFn: usersApis().changePassword.queryFn,
    mutationKey: usersApis().changePassword.queryKey,
  });

  const handleOk = () => {
    form
      .validateFields()
      .then(() => {
        changePass(form.getFieldsValue(), {
          onSuccess: () => {
            setVisiblity(false);
            form.resetFields();
          },
        });
      })
      .catch(() => {});
  };

  const handleClose = () => {
    setVisiblity(false);
    form.resetFields();
  };

  return (
    <Modal
      open={visible}
      title="Change Password"
      onCancel={handleClose}
      footer={[
        <Button key="back" onClick={handleClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          loading={changing}
          type="primary"
          onClick={handleOk}
        >
          Change Password
        </Button>,
      ]}
    >
      <div className="py-3">
        <Form
          form={form}
          layout="vertical"
          name="change_password_form"
          initialValues={{ remember: true }}
        >
          <Form.Item
            name="password"
            label="New Password"
            rules={[
              {
                required: true,
                message: "Please input your new password!",
              },
            ]}
            hasFeedback
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm_password"
            label="Confirm Password"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
